(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.bbCarouselReady === 'true') return;

    var track = root.querySelector('.bb-message-carousel__track');
    var slides = root.querySelectorAll('.bb-message-carousel__slide');
    if (!track || !slides.length) return;

    root.dataset.bbCarouselReady = 'true';

    var index = 0;
    var interval = parseInt(root.dataset.interval || '5000', 10);
    var timer = null;
    var prevBtn = root.querySelector('[data-bb-carousel-prev]');
    var nextBtn = root.querySelector('[data-bb-carousel-next]');

    if (slides.length < 2) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
      return;
    }

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';

      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });
    }

    function startAuto() {
      window.clearInterval(timer);
      timer = window.setInterval(function () {
        goTo(index + 1);
      }, interval);
    }

    function userStep(direction) {
      goTo(index + direction);
      startAuto();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        userStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        userStep(1);
      });
    }

    goTo(0);
    startAuto();
  }

  function initAll() {
    document.querySelectorAll('[data-bb-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
